import { render, staticRenderFns } from "./reduced.vue?vue&type=template&id=5abe723a&"
import script from "./reduced.vue?vue&type=script&lang=js&"
export * from "./reduced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports